import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { watchNetwork } from '@/logics/utils';
import { onMounted, ref } from 'vue';
import { useStore } from './store/store';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        watchNetwork();
        const store = useStore();
        // モバイル/PC切替
        // windowのwidth
        const windowWidth = ref(window.innerWidth);
        // windowのwidthでモバイル/PC切替
        const calculateWindowWidth = () => {
            windowWidth.value = window.innerWidth;
            store.state.isSmartPhone = windowWidth.value < 960;
        };
        onMounted(() => {
            calculateWindowWidth();
            window.addEventListener('resize', calculateWindowWidth);
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
